import React from 'react'
import { Link } from 'gatsby'
import resolveLink from 'src/utils/resolveLink'
import { type TwoColumnsWithAnImageBlok } from '@/components/Header/New/TwoColumnsWithAnImage'
import { type NavItemGroup, type NavItem } from '@/components/Header/New/nav'
export const TwoColumnsWithAnImage = (items: TwoColumnsWithAnImageBlok) => {
  console.log({ two: items })
  return (
    <div>
      <div className="text-lg font-bold text-darkblue">
        {items.first_column_label}
      </div>
      <div className="grid grid-cols-1 w-screen max-w-max gap-4">
        <div className="font-display col-span-1">
          <div className="grid grid-cols-1 justify-start">
            {Object.values(items.first_column_item).map(
              // @ts-ignore: @TODO: fix the type error on NavItemGroup
              (item: NavItemGroup, idx) => {
                return (
                  <div key={idx} className="grid grid-cols-1 gap-4 mt-2">
                    <Link
                      className="font-semibold text-md uppercase text-brightgreen grid grid-cols-1 space-y-4 hover:text-brightgreen/50"
                      to={resolveLink(item.group_label_link)}
                    >
                      {item.group_label}
                    </Link>
                    {item.group_links &&
                      item.group_links.map((subItem: NavItem, subIdx) => {
                        return (
                          <div key={subIdx}>
                            <Link
                              className="bg-gray-200/80 text-xs text-darkblue hover:text-brightgreen rounded-full py-2 px-4"
                              to={resolveLink(subItem.link)}
                            >
                              {subItem.text}
                            </Link>
                          </div>
                        )
                      })}
                  </div>
                )
              },
            )}
            <div className="mt-4">
              <img
                className="max-w-[250px] max-h-[250px] object-contain"
                src={items.first_column_image}
                alt={items.first_column_label}
              />
            </div>
          </div>
        </div>
        <div className="font-display col-span-2">
          <span className="font-bold  font-lg text-darkblue">
            {items.second_column_label}
          </span>
          <div className="grid grid-cols-1 items-start justify-between gap-4">
            {Object.values(items.second_column_items).map(
              // @ts-ignore: @TODO: fix the type error on NavItemGroup
              (item: NavItemGroup, idx) => {
                return (
                  <div key={idx} className="grid grid-cols-1 gap-4 mt-2">
                    <Link
                      className="text-md font-normal uppercase text-brightgreen grid grid-cols-1 space-y-4 hover:text-brightgreen/50"
                      to={resolveLink(item.group_label_link)}
                    >
                      {item.group_label}
                    </Link>
                    {item.group_links &&
                      item.group_links.map((subItem: NavItem, subIdx) => {
                        return (
                          <div key={subIdx}>
                            <Link
                              className="bg-gray-200/80 text-xs text-darkblue hover:text-brightgreen rounded-full py-2 px-4"
                              to={resolveLink(subItem.link)}
                            >
                              {subItem.text}
                            </Link>
                          </div>
                        )
                      })}
                  </div>
                )
              },
            )}
          </div>
        </div>
      </div>
    </div>
  )
}
